import { render, staticRenderFns } from "./TreeRatificaciones.vue?vue&type=template&id=5a3af567&scoped=true"
import script from "./TreeRatificaciones.vue?vue&type=script&lang=js"
export * from "./TreeRatificaciones.vue?vue&type=script&lang=js"
import style0 from "./TreeRatificaciones.vue?vue&type=style&index=0&id=5a3af567&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3af567",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3af567')) {
      api.createRecord('5a3af567', component.options)
    } else {
      api.reload('5a3af567', component.options)
    }
    module.hot.accept("./TreeRatificaciones.vue?vue&type=template&id=5a3af567&scoped=true", function () {
      api.rerender('5a3af567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/TreeRatificaciones.vue"
export default component.exports